class PinToTop {
  constructor(options) {
    this.box = document.querySelector(options)
    this.btn = this.box.querySelector('.pin-a')
    this.init()
  }
  init () {
    const wH = document.documentElement.clientHeight
    let Tp1 = document.documentElement.scrollTop || document.body.scrollTop
    this.box.classList[Tp1 >= wH ? 'add' : 'remove']('active')

    window.addEventListener('scroll', () => {
      let Tp = document.documentElement.scrollTop || document.body.scrollTop
      this.box.classList[Tp >= wH ? 'add' : 'remove']('active')
    })

    this.btn.addEventListener('click', () => {
      this.btnClickEvent()
    })
  }
  btnClickEvent () {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
  }
}

